import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { IDataImportService } from "services/DataImportService";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { selectActiveSubmission } from "../../ActiveSubmissionSlice";
import { findSheetMappingsForWorksheet } from "../../sheetMappings";
import { writeErrorMessage } from "../../../shared/submissionErrors";

// Removes the worksheets' column mapping from the server. False when the request failed or the user has since opened another submission.
export const clearWorksheetMapping = createAsyncThunk<
  boolean,
  { submissionID: string; worksheets: string[] },
  { state: RootState }
>("DataImport/ClearWorksheetMapping", async (arg, { getState }) => {
  const sheetMappings = getState().dataImportUpload.SheetMappings ?? [];
  const sheetMappingsForWorksheets = arg.worksheets.flatMap((worksheet) =>
    findSheetMappingsForWorksheet(sheetMappings, worksheet)
  );
  if (sheetMappingsForWorksheets.length > 0) {
    const dataImportService = container.get<IDataImportService>(SERVICE_TYPES.DataImportService);
    try {
      await dataImportService.saveColumnMappings(
        arg.submissionID,
        sheetMappingsForWorksheets.map((sheetMapping) => ({
          submissionSheetMappingID: sheetMapping.submissionSheetMappingID,
          columnMappingsConfirmed: false,
          columnMappings: [],
        }))
      );
    } catch (error) {
      const worksheetNames = arg.worksheets.join(", ");
      toast.error(
        writeErrorMessage(
          error,
          `Couldn't clear the column mapping for ${worksheetNames}, so nothing was changed. Please try again.`
        )
      );
      return false;
    }
  }
  return selectActiveSubmission(getState())?.submissionID === arg.submissionID;
});
